import React from "react";

import { NavBar as NavBarComponent } from "@components/Navigation/NavBar";

import { TestWrapper } from "@ui/Atoms/TestWrapper";

import { useAuth } from "@hooks/useAuth";

import { NavBarProvider } from "./hooks/useNavBar";
import { useMainNav, scrollToHandler } from "./hooks/useMainNav";
import * as HorizontalNav from "./HorizontalNav";
import { LanguageSelector } from "./LanguageSelector";
import { MobileMenu } from "./MobileMenu";
import { AccountMenu } from "./AccountMenu";
import { Props } from "./NavBar.types";
import * as Styled from "./NavBar.styled";

export const NavBar: React.FC<React.PropsWithChildren<Props>> = ({
  language,
  isSSG = false,
}) => {
  const { isUserAgent } = useAuth();
  const navLinks = useMainNav(language);

  return (
    <NavBarProvider language={language} isSSG={isSSG}>
      <NavBarComponent testId="" id={isSSG ? "header" : undefined}>
        <TestWrapper testId="">
          <Styled.LogoContainer>
            <a href={`/${language}/`}>
              <Styled.Logo />
            </a>
          </Styled.LogoContainer>
        </TestWrapper>

        {!isUserAgent && (
          <Styled.MainNav>
            <HorizontalNav.Nav>
              {navLinks.map(link => (
                <li key={link.testId}>
                  <TestWrapper testId={link.testId}>
                    <HorizontalNav.Link
                      as="a"
                      href={link.href}
                      target={link.target}
                      $style={{
                        default: "medium_14",
                        smallDesktop: "medium_18",
                      }}
                      onClick={scrollToHandler}
                    >
                      {link.label}
                    </HorizontalNav.Link>
                  </TestWrapper>
                </li>
              ))}
            </HorizontalNav.Nav>
          </Styled.MainNav>
        )}

        <Styled.ActionsGroup>
          <AccountMenu />

          <MobileMenu />
          <LanguageSelector />
        </Styled.ActionsGroup>
      </NavBarComponent>
    </NavBarProvider>
  );
};
